#import "src/queries/fragments/groupFragment.graphql"

mutation updateGroupNameWithOption(
  $groupId: ID!
  $name: String!
  $optionId: ID
) {
  result: updateGroupNameWithOption(
    groupId: $groupId
    name: $name
    optionId: $optionId
  ) {
    id
    name
    type
    hierarchyIds
    hierarchy
  }
}

mutation createTeamWithOption(
  $parentId: String!
  $name: String!
  $type: String!
  $optionId: ID
) {
  team: createTeamWithOption(
    parentId: $parentId
    name: $name
    type: $type
    optionId: $optionId
  ) {
    id
    name
    type
    hierarchyIds
    hierarchy
  }
}

mutation updateGroupTypeWithOption(
  $groupId: ID!
  $type: String!
  $optionId: ID
) {
  result: updateGroupTypeWithOption(
    groupId: $groupId
    type: $type
    optionId: $optionId
  ) {
    id
    name
    type
    hierarchyIds
    hierarchy
  }
}

mutation updateGroupTypeRestrictedWithOption(
  $groupId: ID!
  $type: String!
  $optionId: ID
) {
  result: updateGroupTypeRestrictedWithOption(
    groupId: $groupId
    type: $type
    optionId: $optionId
  ) {
    id
    name
    type
    hierarchyIds
    hierarchy
  }
}

mutation updateGroupAttributesWithOption(
  $groupId: ID!
  $attributes: [AttributesInput]
  $optionId: ID
) {
  group: updateGroupAttributesWithOption(
    groupId: $groupId
    attributes: $attributes
    optionId: $optionId
  ) {
    ...GroupFragment
  }
}

mutation updatePersonAttributesWithOption(
  $entityId: ID!
  $attributes: [AttributesInput]
  $optionId: ID
) {
  person: updatePersonAttributesWithOption(
    entityId: $entityId
    attributes: $attributes
    optionId: $optionId
  ) {
    aggregateId
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
    allAttributes {
      id
      attributeType
      subtype
      label
      value
    }
  }
}

mutation updatePersonManagerWithOption(
  $personId: ID!
  $managerId: ID!
  $optionId: ID
) {
  person: updatePersonManagerWithOption(
    personId: $personId
    managerId: $managerId
    optionId: $optionId
  ) {
    aggregateId
    managedBy {
      aggregateId
    }
  }
}

mutation changePersonSupplyGroupWithOption(
  $personId: ID!
  $groupId: ID
  $optionId: ID
) {
  result: changePersonSupplyGroupWithOption(
    personId: $personId
    groupId: $groupId
    optionId: $optionId
  )
}

mutation markGroupAsHiddenWithOption(
  $id: String!
  $isHidden: Boolean
  $optionId: ID
) {
  team: markGroupAsHiddenWithOption(
    id: $id
    isHidden: $isHidden
    optionId: $optionId
  ) {
    id
    isHidden
  }
}

mutation removeTeamSubtreeFromOrgWithOption(
  $rootGroupId: String!
  $allocationProjectId: String
  $optionId: ID
) {
  removeTeamSubtreeFromOrgWithOption(
    rootGroupId: $rootGroupId
    allocationProjectId: $allocationProjectId
    optionId: $optionId
  ) {
    rootGroupId
    hiddenGroupIds
    membershipsEndedCount
    allocationsClearedCount
  }
}

mutation bulkMoveIndividualsRealTimeWithOption(
  $input: MoveIndividualsInput!
  $optionId: ID!
) {
  result: bulkMoveIndividualsRealTimeWithOption(
    input: $input
    optionId: $optionId
  ) {
    directGroups {
      id
    }
  }
}

mutation allocateIndividualRealTimeWithOption(
  $input: AllocateIndividualInput!
  $optionId: ID!
) {
  result: allocateIndividualRealTimeWithOption(
    input: $input
    optionId: $optionId
  ) {
    directGroups {
      id
    }
  }
}

mutation updateEntityTagWithOption(
  $input: UpdateEntityTagInput!
  $includeAppliedCount: Boolean = true
  $optionId: ID
) {
  tag: updateEntityTagWithOption(input: $input, optionId: $optionId) {
    id
    tagId
    type
    replace
    entityId
    entityTagAttributes
    status
    entityType
    tag {
      id
      displayValue
      type
      attributes
      appliedCount @include(if: $includeAppliedCount)
      isActive
    }
  }
}

mutation moveGroupRealTimeWithOption($input: MoveGroupInput!, $optionId: ID!) {
  result: moveGroupRealTimeWithOption(input: $input, optionId: $optionId) {
    validationError
    directGroups {
      ...GroupFragment
    }
  }
}

mutation addMembershipWithOption($input: AddMembershipInput!, $optionId: ID!) {
  results: addMembershipWithOption(input: $input, optionId: $optionId) {
    person {
      aggregateId
    }
  }
}

mutation removeMembershipWithOption(
  $input: RemoveMembershipInput!
  $optionId: ID!
  $personId: ID!
  $groupId: ID!
  $type: String
) {
  results: removeMembershipWithOption(
    input: $input
    optionId: $optionId
    personId: $personId
    groupId: $groupId
    type: $type
  ) {
    person {
      aggregateId
    }
  }
}

mutation updateMembershipWithOption(
  $input: UpdateMembershipInput!
  $optionId: ID!
  $personId: ID!
  $groupId: ID!
) {
  results: updateMembershipWithOption(
    input: $input
    optionId: $optionId
    personId: $personId
    groupId: $groupId
  ) {
    person {
      aggregateId
    }
  }
}

mutation fillPositionVacancyWithOption(
  $input: FillPositionVacancyInput!
  $optionId: ID!
  $groupId: ID
) {
  results: fillPositionVacancyWithOption(
    input: $input
    optionId: $optionId
    groupId: $groupId
  ) {
    isTriggered
    triggerRejectReasons
    person {
      aggregateId
    }
    position {
      id
    }
  }
}

mutation vacatePositionWithOption(
  $input: VacatePositionInput!
  $optionId: ID!
  $groupId: ID
) {
  results: vacatePositionWithOption(
    input: $input
    optionId: $optionId
    groupId: $groupId
  ) {
    person {
      aggregateId
    }
    position {
      id
    }
  }
}

mutation addPositionWithOption($input: AddPositionInput!, $optionId: ID!) {
  result: addPositionWithOption(input: $input, optionId: $optionId) {
    id
    person {
      aggregateId
      preferredName
      fte
      jobTitle
      city
      country
      state
      bands
      isVacancy
      managedBy {
        aggregateId
        preferredName
      }
    }
    establishedFte
    startDate
    endDate
  }
}

mutation updatePositionWithOption(
  $input: UpdatePositionInput!
  $optionId: ID!
) {
  result: updatePositionWithOption(input: $input, optionId: $optionId) {
    id
    person {
      aggregateId
      preferredName
      fte
      jobTitle
      city
      country
      state
      bands
      isVacancy
      managedBy {
        aggregateId
        preferredName
      }
    }
    establishedFte
    startDate
    endDate
  }
}

mutation addTagToEntityWithOption(
  $entityId: ID!
  $entityType: String
  $tagId: ID!
  $replace: Boolean!
  $comments: TaggingComments
  $includeAppliedCount: Boolean = false
  $optionId: ID
) {
  result: addTagToEntityWithOption(
    entityId: $entityId
    entityType: $entityType
    tagId: $tagId
    replace: $replace
    comments: $comments
    optionId: $optionId
  ) {
    id
    tagId
    type
    replace
    entityId
    entityTagAttributes
    status
    entityType
    tag {
      id
      displayValue
      type
      attributes
      appliedCount @include(if: $includeAppliedCount)
      isActive
    }
  }
}

mutation addNewTagToEntityWithOption(
  $entityId: ID!
  $entityType: String
  $tagType: TagType!
  $displayValue: String!
  $attributes: JSON
  $replace: Boolean!
  $comments: TaggingComments
  $includeAppliedCount: Boolean = false
  $optionId: ID
) {
  result: addNewTagToEntityWithOption(
    input: {
      entityId: $entityId
      entityType: $entityType
      type: $tagType
      displayValue: $displayValue
      attributes: $attributes
      replace: $replace
      comments: $comments
    }
    optionId: $optionId
  ) {
    id
    tagId
    type
    replace
    entityId
    entityTagAttributes
    status
    entityType
    tag {
      id
      displayValue
      type
      attributes
      appliedCount @include(if: $includeAppliedCount)
      isActive
    }
  }
}

mutation removeTagFromEntityWithOption(
  $entityId: ID!
  $entityType: String
  $tagId: ID!
  $comments: TaggingComments
  $optionId: ID
) {
  result: removeTagFromEntityWithOption(
    entityId: $entityId
    entityType: $entityType
    tagId: $tagId
    comments: $comments
    optionId: $optionId
  ) {
    id
    tagId
    appliedCount
  }
}

mutation addAssociationV2WithOption(
  $input: AddAssociationInput!
  $optionId: ID
) {
  addAssociationV2WithOption(input: $input, optionId: $optionId) {
    id
    tagId
    displayValue
    metadata {
      id
      name
      description
      allowedDisplayValues
      allowMultipleOnEntity
    }
    entities {
      id
      name
    }
    scope {
      id
      name
      description
    }
  }
}

mutation removeAssociationWithOption(
  $input: RemoveAssociationInput!
  $optionId: ID
) {
  removeAssociationWithOption(input: $input, optionId: $optionId) {
    id
    tagId
    displayValue
  }
}

mutation updatePersonFieldsWithOption(
  $entityId: ID!
  $input: UpdatePersonFieldsInput!
  $optionId: ID
) {
  person: updatePersonFieldsWithOption(
    entityId: $entityId
    input: $input
    optionId: $optionId
  ) {
    aggregateId
    fte
  }
}

mutation updateTagValueWithOption($input: UpdateTagInput!, $optionId: ID) {
  tag: updateTagWithOption(input: $input, optionId: $optionId) {
    id
    type
    displayValue
    isActive
    attributes
    appliedCount
  }
}
